
import BrandImageComponent from "@/components/recorder/partials/BrandImageComponent.vue";
import FullHeaderComponent from "@/components/recorder/partials/FullHeaderComponent.vue";
import FooterComponent from "@/components/recorder/partials/FooterComponent.vue";
import {defineComponent, PropType} from "vue";
import {Campaign} from "@/models/campaign";
import {Contribution} from "@/models/contribution";
import BackgroundImageMixin from "@/components/recorder/BackgroundImageMixin.vue";

export default defineComponent({
    name: "NPSComponent",
    components: {FooterComponent, FullHeaderComponent, BrandImageComponent},
    mixins: [BackgroundImageMixin],
    props: {
        campaign: {
            type: Object as PropType<Campaign>,
            required: true
        },
        contribution: {
            type: Object as PropType<Contribution>,
            required: true,
        },
    },
    computed: {
        canSubmit(): boolean {
            return this.contribution.rating !== undefined;
        },
        rating: {
            get(): number | undefined {
                return this.contribution.rating;
            },
            set(value: number) {
                this.$emit('setContributionRating', value);
            }
        },
    },
    methods: {
        goToPromptScreen(): void {
            if (this.canSubmit) {
                this.$emit('goToPromptScreen');
            }
        },
    },
});
